import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames, { classNamesFor } from '../../utils/classNames';

var ProductTile = function ProductTile(props) {
  var type = props.type,
      qa = props.qa,
      className = props.className,
      gameArt = props.gameArt,
      productType = props.productType,
      productTypeText = props.productTypeText,
      productName = props.productName,
      serviceUpsell = props.serviceUpsell,
      discountBadge = props.discountBadge,
      price = props.price;

  var _ProductTile$getClass = ProductTile.getClassName(className),
      root = _ProductTile$getClass.root,
      detailsClass = _ProductTile$getClass.details,
      productTypeClass = _ProductTile$getClass.productType,
      nameClass = _ProductTile$getClass.productName;

  var isConcept = type === 'CONCEPT';
  return /*#__PURE__*/React.createElement("div", {
    className: root,
    "data-qa": qa
  }, gameArt && /*#__PURE__*/cloneElement(gameArt, {
    qa: "".concat(qa, "#game-art"),
    className: classNames('psw-ally-indicator', 'psw-ally-indicator-gap-1', 'psw-show-on-hover', 'psw-b-0')
  }), /*#__PURE__*/React.createElement("section", {
    "data-qa": "".concat(qa, "#details"),
    className: detailsClass
  }, productType !== 'FULL_GAME' && productType !== 'BUNDLE' && /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#product-type"),
    className: productTypeClass
  }, productTypeText), productName && /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#product-name"),
    className: nameClass
  }, productName), serviceUpsell && /*#__PURE__*/cloneElement(serviceUpsell, {
    qa: "".concat(qa, "#service-upsell"),
    className: 'psw-m-t-2'
  }), !isConcept && discountBadge && /*#__PURE__*/cloneElement(discountBadge, {
    qa: "".concat(qa, "#discount-badge"),
    className: 'psw-m-t-3 psw-m-b-2'
  }), price && /*#__PURE__*/cloneElement(price, {
    qa: "".concat(qa, "#price"),
    className: classNames('psw-fill-x', price.props.className)
  })));
};

var cx = classNamesFor(ProductTile);

ProductTile.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx('psw-product-tile', 'psw-interactive-root', className),
    link: cx('psw-product-tile-link'),
    details: cx('psw-product-tile__details', 'psw-m-t-2'),
    productType: cx('psw-product-tile__product-type', 'psw-t-bold', 'psw-t-size-1', 'psw-t-truncate-1', 'psw-c-t-2', 'psw-t-uppercase', 'psw-m-b-1'),
    productName: cx('psw-t-body', 'psw-c-t-1', 'psw-t-truncate-2', 'psw-m-b-2')
  };
};

ProductTile.defaultProps = {
  className: '',
  qa: '',
  discountBadge: null,
  serviceUpsell: null
};
ProductTile.propTypes = {
  className: PropTypes.string,
  qa: PropTypes.string,
  type: PropTypes.oneOf(['PRODUCT', 'CONCEPT']).isRequired,
  gameArt: PropTypes.element.isRequired,
  // AKA StoreDisplayClassification
  // See: https://github.sie.sony.com/SIE-Private/arkham-gql/blob/28b71a3cbe0d765beb78f1e0595948a69acf7aa8/src/models/Catalog/enums.ts
  productType: PropTypes.string.isRequired,
  productTypeText: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  serviceUpsell: PropTypes.element,
  discountBadge: PropTypes.element,
  price: PropTypes.element.isRequired
};
export default ProductTile;